// extracted by mini-css-extract-plugin
export default {"wrapper":"side-editor-sections-connection_wrapper__D+6PF","connection":"side-editor-sections-connection_connection__zBwm6"};